import type { RewardKind } from '../home.ts';

/** Shared drawing keeps full-size souvenirs and tiny calendar stamps consistent. */
export function RewardDrawing({ kind }: { kind: RewardKind }) {
  return kind === 'sun' ? (
    <>
      <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <path d="M60 3v8m0 60v8M21 41h-8m94 0h-8M32 13l6 6m44 44 6 6M88 13l-6 6M32 69l6-6" />
        <circle cx="60" cy="41" r="25" fill="#f4d58b" />
        <path d="M47 49q13 12 26 0M39 34h42" />
      </g>
      <path d="M41 33h16v5a7 7 0 0 1-14 0Zm22 0h16l-2 5a7 7 0 0 1-14 0Z" fill="currentColor" />
    </>
  ) : (
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M67 10C43 3 25 22 28 45S53 79 73 64C48 67 35 28 67 10Z" fill="#d5e1d6" />
      <path d="M34 43q5 5 10 0m-5 11q4 4 8 0M87 20v10m-5-5h10M91 51v8m-4-4h8" fill="none" />
    </g>
  );
}
